import * as React from "react";
import { ODataProvider } from "../contexts/ODataContext";
import { DropDownListCustom } from "./DropDownlistCustom";
import { DropDownListCustomHandle } from "./DropDownlistCustom";
import { GridCellProps } from "@progress/kendo-react-grid";

export interface DropDownGridCellProps extends React.RefAttributes<DropDownGridCellHandle> {
  sourceApiUrl: string;
  fieldName: string;
  fieldValue: string;
  filterField: string; 
  filterValue: string; 
  selectedItem: any; 
  disableDropDown: boolean;
  autoBind: boolean;
  gridProps: GridCellProps;
  onChange: (event: any) => void; 
}
export type DropDownGridCellHandle = {
    setValue: (value: any) => void;
    
};
export const DropDownGridCell = React.memo( React.forwardRef<DropDownGridCellHandle,DropDownGridCellProps> ((props, ref) => {
        const [apiUrlSet, setApiUrlSet] = React.useState<string>(props.sourceApiUrl);
        const dropDownRef = React.useRef<DropDownListCustomHandle>(null);
        const field = props.gridProps.field??"";
        const dataValue = props.gridProps.dataItem[props.gridProps.field??""] === null ? "" : props.gridProps.dataItem[field];
        React.useImperativeHandle(ref, () => ({
            setValue
        }));
        const setValue= (value: any) => {
            dropDownRef.current?.settingValue(value);
        }
        React.useEffect(() => {
            dropDownRef.current?.settingValue(props.selectedItem);
            if ((props.filterField && props.filterValue !== "")) {
                dropDownRef.current?.refreshData(props.sourceApiUrl + `?${props.filterField}=${props.filterValue}`); 
            }
        }, [apiUrlSet]);
        
        React.useEffect(() => {
            if ((props.filterField && props.filterValue !== "")) {
                setApiUrlSet(props.sourceApiUrl + `?${props.filterField}=${props.filterValue}`)
            }

        }, [ props.filterValue]);

        return (
        <td>
            {(props.gridProps.dataItem.inEdit  && (props.gridProps.dataItem.CanDelete || !props.disableDropDown))? (
                <ODataProvider baseUrl={apiUrlSet} loadingContent=".k-dropdownlist">
                    <DropDownListCustom KeyField={props.fieldValue}
                        ref={dropDownRef} 
                        Label={""}
                        PageSize={30} 
                        PlaceHolder={"Search"} 
                        TextField={props.fieldName} 
                        onChange={props.onChange} 
                        isInlineEdit={true} 
                        AutoBind={props.autoBind}/>
                </ODataProvider>  
            ) : dataValue }
        </td>
  );
}));

export default DropDownGridCell;